import axios from 'axios';
import END_POINT from 'src/config/endpoints.constants';
import { getDetailedErrorMessage } from 'src/customer-call-sdk/lib/API';
import { API_RESPONSE_CODE } from 'src/customer-call-sdk/config/constants';
import { VriAPIResult } from '../types';

export interface RequestAccountDeletionResult extends VriAPIResult {
    code?: number;
    message?: string;
}

export const requestAccountDeletion = async (
    userId: string,
): Promise<RequestAccountDeletionResult> => {
    const result: RequestAccountDeletionResult = {};

    try {
        const { data: responseData } = await axios.post(`${END_POINT.ACCOUNT_DELETION}`, {
            userId,
        });

        result.code = responseData.code;
        result.message = responseData.message;

        if (responseData.code !== API_RESPONSE_CODE.SUCCESS) {
            result.error = responseData.message;
        }
    } catch (err) {
        result.error = getDetailedErrorMessage(err);
    }
    return result;
};
